import { useEffect, useState } from "react";

export const Timer = () => {
    const [sec, setSec] = useState(0);
    let temp = new Date();
    temp = temp.setSeconds(temp.getSeconds() + 60);
   
    useEffect(() => {
    const intervalId = setInterval(() => {
    let Enddate = new Date(temp).getTime();
    let countDownDate = Enddate;
    let now = new Date().getTime();
    let timeleft = countDownDate - now;
    let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
   
    if (timeleft > 0) {
    setSec(seconds);
    }
    }, 1000);
   
    return () => {
    clearInterval(intervalId);
    };
    }, []);
   
    const value = "00 :" + sec
    return value
   };